import type {
  AddedOrRemovedField,
  Filters,
  NumberFields,
  StringFields,
} from './types';

export function checkIfNumber<T>(value: unknown, fallback: T): number | T {
  if (typeof value === 'undefined') {
    return fallback;
  }
  const number = Number(value);
  if (typeof number !== 'number' || Number.isNaN(number)) {
    return fallback;
  }
  if (number < 0 || number >= 1000000000) {
    return fallback;
  }
  return number;
}
export type ValueOf<T> = T[keyof T];

const numberFields: Array<keyof Filters> = [
  'spend_min',
  'spend_max',
  'rank_min',
  'rank_max',
  'employees_min',
  'employees_max',
];

const stringFields: Array<keyof Filters> = [
  'tld',
  'country',
  'vertical',
  'industries',
  'tags',
];

export const isNumber = (value: unknown): value is number => {
  return (
    typeof value === 'number' &&
    !isNaN(value) &&
    value > 0 &&
    value < 1000000000
  );
};

export const isStringField = (field: string): field is keyof StringFields => {
  return stringFields.includes(field as keyof StringFields);
};
export const isNumberField = (field: string): field is keyof NumberFields => {
  return numberFields.includes(field as keyof NumberFields);
};

export const isAddedField = (
  field: string
): field is keyof AddedOrRemovedField => {
  return field.startsWith('added_');
};
export const isRemovedField = (
  field: string
): field is keyof AddedOrRemovedField => {
  return field.startsWith('removed_');
};

export const isAddedOrRemovedField = (
  field: string
): field is keyof AddedOrRemovedField => {
  return isAddedField(field) || isRemovedField(field);
};
